const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://tttt6ydshk.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://fxtuyh5vv0.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://5p24xuq6yf.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'hotfix/CV4-3154-duplicate-client-id-409',
    HOSTNAME: 'https://locations.dev.apps.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.dev.apps.forwoodsafety.com',
    WEBSOCKET: 'wss://w7wfrjk2l6.execute-api.us-west-2.amazonaws.com/dev'
  },
};

export default config;